"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defineAppConfig_1 = require("../defineAppConfig");
exports.default = (0, defineAppConfig_1.defineAppConfig)({
    appName: 'あばれる君のアドベンチャークラブ',
    organizationId: 'awBRwVLjlfPepuDoCaOx',
    applicationKey: 'abarerukun',
    applicationType: 'standalone',
    artistId: '34hywLE4yEOwV2lcmYPkoFvQfi12',
    version: '1.1',
    deeplinkUrl: 'https://abarerukun.utoniq.com',
    helpUrl: 'https://help.utoniq.com/ja/collections/2299305',
    deeplinkProd: 'abarerukun.utoniq.com',
    deeplinkStg: 'abarerukun-stg.netlify.app',
    custom: {
        modules: {
            membership: true,
            thread: true,
            item: true,
            store: true,
            preSale: true,
            event: true,
            cart: true,
            konbiniPayment: true,
        },
        tutorials: [
            'images/tutorial/Tutorial02.png',
            'images/tutorial/Tutorial04.png',
        ],
        globalTabs: [],
        artistTabs: ['home', 'posts', 'store', 'events', 'myProfile'],
    },
});
